/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/",
    name: "Dashboard",
    slug: "dashboard",
    icon: "HomeIcon",
  },
  {
    url: "/contact",
    name: "Contact",
    slug: "contact",
    icon: "UserIcon",
  },
  {
    url: null,
    name: "Emails",
    icon: "MailIcon",
    submenu: [
      {
        url: '/general-editor/email-accept',
        name: "Email account accepteren",
        slug: "general-editor/email-accept",
      },
      {
        url: '/general-editor/email-order',
        name: "Email bestelling gelukt",
        slug: "general-editor/email-order",
      },
      {
        url: '/general-editor/email-failure',
        name: "Email bestelling mislukt",
        slug: "general-editor/email-failure",
      },
      {
        url: '/general-editor/email-requested',
        name: "Email account aangevraagd",
        slug: "general-editor/email-requested",
      },
      ]
  },
  {
    url: null,
    name: "Paginas",
    icon: "FileTextIcon",
    i18n: "Dashboard",
    submenu: [
      {
        url: '/home-editor',
        name: "Home pagina",
        slug: "home-editor",
      },
      {
        url: '/about-us-editor',
        name: "Over Gastro Inox",
        slug: "about-us-editor",
      },
      {
        url: '/catalogus-editor',
        name: "Catalogus",
        slug: "catalogus-editor",
      },
      {
        url: '/general-editor/vacatures',
        name: "Vacatures",
        slug: "general-editor/vacatures",
      },
      {
        url: '/general-editor/algemene-voorwaarden',
        name: "Algemene voorwaarden",
        slug: "general-editor/algemene-voorwaarden",
      },
      {
        url: '/general-editor/disclaimer',
        name: "Disclaimer",
        slug: "general-editor/disclaimer",
      },
      {
        url: '/general-editor/copyright',
        name: "Copyright",
        slug: "general-editor/copyright",
      },
      {
        url: '/general-editor/privacy',
        name: "Privacy policy",
        slug: "general-editor/privacy",
      },
      {
        url: '/general-editor/service',
        name: "Service en storingen",
        slug: "general-editor/service",
      },
      {
        url: '/general-editor/garantie',
        name: "Garantie",
        slug: "general-editor/garantie",
      },

    ]
  },
  {
    url: "/file-upload",
    name: "Bestanden uploaden",
    slug: "file-upload",
    icon: "FileIcon",
  },
  {
    url: "/discount-rules",
    name: "Kortingen",
    slug: "discount-rules",
    icon: "PercentIcon",
  },
  {
    url: "/payment-methods",
    name: "Payment methods",
    slug: "payment-methods",
    icon: "CurrencyIcon",
  },
  {
    url: "/shipping",
    name: "Verzendkosten",
    slug: "shipping",
    icon: "TruckIcon",
  },
]
